import { render } from "./RoleManager.vue?vue&type=template&id=bcf42806"
import script from "./RoleManager.vue?vue&type=script&lang=js"
export * from "./RoleManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__